import { AuthProvider } from 'react-admin';
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  User,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:3000';

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, username, password);
      const token = await userCredential.user.getIdToken();

      const response = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Login failed');
      }

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify({
        uid: userCredential.user.uid,
        email: userCredential.user.email,
      }));

      return Promise.resolve();
    } catch (error: any) {
      return Promise.reject(new Error(error.message || 'Login failed'));
    }
  },

  logout: async () => {
    await signOut(auth);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return Promise.resolve();
  },

  checkAuth: () => {
    return new Promise((resolve, reject) => {
      const unsubscribe = onAuthStateChanged(auth, async (user: User | null) => {
        unsubscribe();
        if (user) {
          const token = await user.getIdToken();
          localStorage.setItem('token', token);
          resolve();
        } else {
          reject();
        }
      });
    });
  },

  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getIdentity: async () => {
    const user = localStorage.getItem('user');
    if (user) {
      const parsed = JSON.parse(user);
      return Promise.resolve({
        id: parsed.uid,
        fullName: parsed.email,
      });
    }
    return Promise.reject();
  },

  getPermissions: () => Promise.resolve(''),
};
